import axios from "axios";

const url = process.env.REACT_APP_API_URL_REPORT;

export default class ReportService {
    getAll() {
        return axios.get(url + '/ppk')
    }

    getFrequensi() {
        return axios.get(url + '/getfrequensi')
    }

    getFrequensiUpt() {
        return axios.get(url + '/getfrequensiupt')
    }

    getCntFreq() {
        return axios.get(url + '/getsumfrequensi')
    }

    getFrequensiNegara() {
        return axios.get(url + '/getfrequenisnegara')
    }

    getPropinsiIzin(sDate, eDate) {
        return axios.get(`${url}/gabungan-primer/pivot-propinsi-izin?tgl_awal=${sDate}&tgl_akhir=${eDate}`)
    }
}
